/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import EditableTextField from "./editableTextField";
import axios from "axios";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
  getUserData
} from "../redux/slices/homeSlice";
import { useSelector, useDispatch } from "react-redux";

const org = localStorage.getItem("org");
const Auth = localStorage.getItem("Auth");
const access_token = localStorage.getItem("Auth");

const dominname = window.location.origin;



export default function shareLink({
  item,
  changeShareLinkActiveDeavtive,
  generteShareLink,
  index,
  deleteManageSource,
}) {
  const navigator = useNavigate();
    const dispatch = useDispatch();
    const [feed, setFeed] = useState();
    const [managerOption, setManagerOption] = useState('');
    const [defaultManager, setDefaultManager] = useState('');
    const [leadVisibility, setLeadVisibility] = useState('item_owner');

  
    const handleSubmit = async (e) => {
      e.preventDefault();
    
      const configData = {
        manager_option: managerOption,
        default_manager: managerOption === 'default' ? defaultManager : null,
        lead_visibility: leadVisibility,
        source: item.Source,
      };
    
      console.log(configData, "configData");
    
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Auth}`, // Make sure Auth contains a valid token string
      };
    
      try {
        const res = await axios.post('/Add_Source_Configuration', configData, { headers });
        alert('Configuration saved successfully!');
        console.log(res.data);
      } catch (err) {
        console.error(err);
        alert('Failed to save configuration. Try again.');
      }
    };





  const activeDeactive = (item) => {
    if (item.IsShared == true) {
      return (
        <i
          title="Activate Link"
          className="i bi-toggle2-on"
          style={{ cursor: "pointer" }}
          onClick={() => changeShareLinkActiveDeavtive(item.Source, false)}
        ></i>
      );
    } else if (item.IsShared == false) {
      return (
        <i
          title="Activate Link"
          className="i bi-toggle2-off"
          style={{ cursor: "pointer" }}
          onClick={() => changeShareLinkActiveDeavtive(item.Source, true)}
        ></i>
      );
    }
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {props}
    </Tooltip>
  );

  function onBlurUpdatePassword(data, password) {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Auth}`,
    };

    axios
      .post(
        "/Set_PassWord_forSource",
        {
          "Contact_Source": data.Source,
          "password": password 
        },
        { headers }
      )
      .then((data) => {
        if (data.status == "200") {
        }
        
      })
      .catch((err) => console.log(err));
  }
  
  function fetchUserData() {
    dispatch(getUserData({ access_token, org })).then((res) => {
      if (res.payload.status == 200) {
        setFeed(res.payload.data);
      }
    });
    
  }


  function getConfig() {

    axios.get("/Get_Source_Configuration", {
      params: { source: item.Source, org: org },
      headers: { "Content-Type": "application/json" },
    })
      .then((data) => {
        if (data.status == "200") {
          setManagerOption(data.data.manager_option);
          if (data.data.manager_option === 'default') {
            setDefaultManager(data.data.default_manager);
          }
          setLeadVisibility(data.data.lead_visibility);
        }
      })
      .catch((err) => console.log(err));
  }

  
  
  function getInfoConfig(){
    fetchUserData();
    getConfig();
      
  };

 

  return (
    <>
      <li
        key={index}
        className="list-group-item d-flex justify-content-between align-items-start text-dark border border-dark"
      >
        <div className="ms-2 me-auto">{item.Source}</div>
        {activeDeactive(item)}
        <i
          title="Share Link"
          class="bi bi-share"
          style={{ marginLeft: "8px", cursor: "pointer" }}
          onClick={()=>getInfoConfig()}
          data-bs-toggle="collapse"
          data-bs-target={`#collapseExample${index}`}
          aria-expanded="false"
          aria-controls={`collapseExample${index}`}
        ></i>
        <i
        title="Delete"
        className="bi bi-trash3-fill"
        style={{ marginLeft: "8px", cursor: "pointer" }}
        data-bs-toggle="modal"
        data-bs-target={`#deleteConfirmModal${index}`}
      />
      </li>
      <div class="collapse" id={`collapseExample${index}`}>
        <div class="card card-body">
          <b><i className="bi bi-file-text"></i> View Link <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip('Share the link below to give your sources current lead status.')}
    >
      <i className="bi bi-info-circle-fill text-dark"></i>
    </OverlayTrigger></b>
    <input className="form-control form-control-sm" type="text" value={dominname+"/viewsource?q="+item.Source+"&og="+org} aria-label=".form-control-sm example" />
        
    <b className="mt-2"><i className="bi bi-shield-lock"></i> Set Password (min 6 character):</b>
          <EditableTextField
      data={item}
      handleBlur={onBlurUpdatePassword}
      keyname="password"
      placeholder="Access Key"

    />

          <b className="mt-2"><i className="bi bi-person-plus"></i> LeadCapture Link <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip('Share the link below to collect lead from your sources.')}
    >
      <i className="bi bi-info-circle-fill text-dark"></i>
    </OverlayTrigger></b>
    <input className="form-control form-control-sm" type="text" value={dominname+"/leadcapture?q="+item.Source+"&og="+org} aria-label=".form-control-sm example" />
          


      <form onSubmit={handleSubmit}>
        {/* Set Manager Options */}
        <div className="mt-2">
          <label className="form-label fw-bold mt-2">Set Manager:</label>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="managerOption"
              value="customer"
              checked={managerOption === 'customer'}
              onChange={() => setManagerOption('customer')}
            />
            <label className="form-check-label">Let customer select manager</label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="managerOption"
              value="default"
              checked={managerOption === 'default'}
              onChange={() => setManagerOption('default')}
            />
            <label className="form-check-label">Set default manager</label>
          </div>

          {managerOption === 'default' && (
            <div className="mt-2">
              <label className="form-label">Assign Manager:</label>
              <select
                className="form-select form-select-sm"
                value={defaultManager}
                onChange={(e) => setDefaultManager(e.target.value)}
                required
              >
                <option value="">-- Select Manager --</option>
                {feed &&
                                          feed?.map((item) => (
                                            <option
                                              value={
                                                item.user_name + "-" + item.id
                                              }
                                            >
                                              {item.user_name}-{item.role}
                                            </option>
                                          ))}
              </select>
            </div>
          )}
        </div>

        {/* Lead Visibility Option */}
        <div className="mt-2">
          <label className="form-label fw-bold">Lead Visibility Default:</label>
          <select
            className="form-select form-select-sm"
            value={leadVisibility}
            onChange={(e) => setLeadVisibility(e.target.value)}
          >
            <option value="Item owner">Item owner & admin </option>
            <option value="All users">All users </option>
            <option value="Only admin">Only admin </option>
          </select>
        </div>

        <button type="submit" className="btn btn-dark btn-sm mt-2">
          Save Configuration
        </button>
      </form>
 
         
          
        </div>
      </div>
      {/* confirmation model */}
      <div
  className="modal fade"
  id={`deleteConfirmModal${index}`}
  tabIndex="-1"
  aria-labelledby="deleteConfirmLabel"
  aria-hidden="true"
>
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="deleteConfirmLabel">Confirm Deletion</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        Are you sure you want to delete <b>{item.Source}</b>? This action cannot be undone.
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-danger btn-sm"
          data-bs-dismiss="modal"
          onClick={() => deleteManageSource(item.Source)}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</div>
    </>
  );
}
